import debounce from 'lodash.debounce'

export function bufferFunction<T>(fn: (input: T[]) => unknown, wait: number) {
  let inputs: T[] = []
  const debouncedFn = debounce(async () => {
    const calledInput = inputs
    inputs = inputs.slice(calledInput.length)
    await fn(calledInput)
  }, wait)

  return (input: T) => {
    inputs.push(input)
    debouncedFn()
  }
}

export function bufferFunctionAsync<T>(
  fn: (input: T[]) => Promise<unknown>,
  wait: number,
) {
  let inputs: T[] = []
  let resolvers: ((value: null) => void)[] = []

  const resolveAll = () => {
    resolvers.forEach((resolve, index) => {
      resolve(null)
      if (index === resolvers.length - 1) resolvers = []
    })
  }

  const debouncedFn = debounce(async () => {
    const calledInput = inputs
    inputs = inputs.slice(calledInput.length)
    await fn(calledInput)
    resolveAll()
  }, wait)

  return (input: T) =>
    new Promise<null>(resolve => {
      inputs.push(input)
      resolvers.push(resolve)
      debouncedFn()
    })
}
